import { useEffect, useState, useRef } from 'react';
import { initialStatePhoneNumber, InputPhone, mobilePhoneToString, Steps, validMobileForInputPhone } from 'medere-ui-framework';
import { Button } from 'primereact/button';
import './NewRecipeView.scss';
import PatientStep from './Steps/PatientStep';
import MedicationStep from './Steps/MedicationStep';
import ConfirmationStep from './Steps/ConfirmationStep';
import { InputTextCustom, Modal, WindowLoader } from 'medere-ui-framework';
import { ERecipeHistoryTab, ERecipeViews, ESteps, EAgendaViews, ETaskMessageType, EMessageType, EProfileDataViews } from '../RecipeEnums';
import { Medicine, Professional, defaultHealthPatientCoverage, HealthPatientCoverage, PatientRecordDTO, RecipeDTO, RecipeResponseDTO, ScheduleMessageResponseDTO, RecipeAuditoryResponseDTO, defaultProfessional } from '../../../interface/interface';
import { Icon } from '@iconify/react';
import { hasSenderPermissionByTaskMessageTypeAndMessageType, saveDigitalRp, saveDigitalRpRequested, sendDigitalRpByMessageSender, savePatient, isGenderNull } from '../../../services/digitalRPservice';
import PdfViewer from '../Components/PdfViewer';
import { Toast, ToastMessage } from 'primereact/toast';
import { customerServiceNumber, whatsappPurchaseText } from '../../../utils/Constants';
import { useRecipeProfessionalData } from '../../../context/RecipeProfessionalDataContext';
import { validateInternationalCellphone } from '../../../utils/utils';
//import Steps from '../../../Components/Steps/Steps';

export default function NewRecipeView(params: { activeView: any, setActiveView: (av: any) => void, subActiveView: number | null, setSubActiveView: (av: number | null) => void, prevActiveView: number | null, setPrevActiveView: (pav: number | null) => void, prevSubActiveView: number | null, setPrevSubActiveView: (pav: number | null) => void, medications: Medicine[] | null, setMedications: (medicine: Medicine[]) => void, selectedPatient: PatientRecordDTO | null, setSelectedPatient: (patient: PatientRecordDTO | null) => void, recipeDate: Date | undefined, setRecipeDate: (rd: Date) => void, prolongedTreatment: boolean, setProlongedTreatment: (prolonged: boolean) => void, hidePatientData: boolean, setHidePatientData: (hiding: boolean) => void, professional: Professional, isProfessional: boolean, requestPrescription: number | null, setRefreshPending: (rp: boolean) => void, monthDurationPrescription: { months: number, description: string }, setMonthDurationPrescription: (mdp: { months: number, description: string }) => void }) {
    const { activeView, setActiveView, subActiveView, setSubActiveView, prevActiveView, setPrevActiveView, prevSubActiveView, setPrevSubActiveView, medications, setMedications, selectedPatient, setSelectedPatient, recipeDate, setRecipeDate, prolongedTreatment, setProlongedTreatment, hidePatientData, setHidePatientData, professional, isProfessional, requestPrescription, setRefreshPending, monthDurationPrescription, setMonthDurationPrescription } = params;
    const toast = useRef(null)
    const [activeStep, setActiveStep] = useState(subActiveView && subActiveView !== 0 ? subActiveView : ESteps.PATIENTSTEP);
    const [isStepValid, setIsStepValid] = useState((prevActiveView === ERecipeViews.PATIENTAGENDA && prevSubActiveView === EAgendaViews.CREATEPATIENTVIEW) ? true : false);
    const [selectedCoverage, setSelectedCoverage] = useState<HealthPatientCoverage | undefined>(selectedPatient ? selectedPatient.insurances?.find(insurance => insurance.primarycoverage) || defaultHealthPatientCoverage : defaultHealthPatientCoverage);

    const [diagnosisError, setDiagnosisError] = useState(false);

    const [requiresAuditory, setRequiresAuditory] = useState(false);

    const [sendModalVisible, setSendModalVisible] = useState(false);
    const [cancelModalVisible, setCancelModalVisible] = useState(false);
    const [openErrorRecipeValidationModal, setOpenErrorRecipeValidationModal] = useState(false);
    const [openHandleBackFromMedicationStepModal, setOpenHandleBackFromMedicationStepModal] = useState(false);
    const [sendedRecipeModal, setSendedRecipeModal] = useState(false)
    const [openAuditoryModal, setOpenAuditoryModal] = useState(false);

    const [openEditMobilephoneModal, setOpenEditMobilephoneModal] = useState(false);
    const [newMobilephone, setNewMobilephone] = useState('');
    const [openEditMailModal, setOpenEditMailModal] = useState(false);
    const [newMail, setNewMail] = useState('');

    const [newRp, setNewRp] = useState<RecipeDTO>();
    const [recipeResponse, setRecipeResponse] = useState<RecipeResponseDTO[]>([]);
    const [notSuccessfulList, setNotSuccessfulList] = useState<RecipeResponseDTO[] | null>(null);
    const [successfulList, setSuccessfulList] = useState<RecipeResponseDTO[]>();
    const [pdfRecipeList, setPdfRecipeList] = useState<string[]>([]);
    const [hasMinimunPatientData, setHasMinimunPatientData] = useState(false)
    const [allProfileDataFilled, setAllProfileDataFilled] = useState<boolean | string | undefined>(false);
    const [viaSended, setViaSended] = useState<number | null>()

    const [disabledWhatsapp, setDisabledWhatsapp] = useState<boolean>(true);
    const [disabledEmail, setDisabledEmail] = useState<boolean>(true);

    const [loading, setLoading] = useState(false);
    const [paddingTop, setPaddingTop] = useState('50%');
    const [isMobile, setisMobile] = useState(window.innerWidth < 700)

    const { setErrorProfileDataFields } = useRecipeProfessionalData();

    const [patientPhone, setPatientPhone] = useState(initialStatePhoneNumber);

    const steps = [
        { label: 'Paciente' },
        { label: 'Medicamentos' },
        { label: 'Confirmación' },
    ];

    const showMessage = (ref: React.RefObject<Toast>, msg: any, severity: ToastMessage['severity']) => {
        ref.current?.show({ severity: severity, summary: msg, life: 3000 });
    };
    const showLongMessage = (ref: React.RefObject<Toast>, msg: any, severity: ToastMessage['severity']) => {
        const content = (
            <div style={{ fontWeight: 600 }}>
                {msg}
            </div>
        );
        ref.current?.show({ severity: severity, summary: msg, life: 3000, content: content });
    };

    useEffect(() => {
        if (prevActiveView === ERecipeViews.PATIENTAGENDA && prevSubActiveView === EAgendaViews.CREATEPATIENTVIEW) { //si vuelve de editar datos del paciente por tener credenciales invalidas en ConfirmationStep, setea isStepValid en true y desSetea los prev
            setPrevActiveView(undefined)
            setPrevSubActiveView(undefined)
        }

        if (subActiveView !== ESteps.PATIENTSTEP && selectedPatient?.medereentity != null && selectedPatient?.medereentity != undefined) { //si subActiveView es PatientStep, viene de editar paciente desde PatientStep, por lo que no me debe llevar al paso de medicamentos
            setActiveStep(ESteps.MEDICATIONSTEP)
        }
        else {
            setActiveStep(ESteps.PATIENTSTEP)
        }

        const handleResize = () => {
            setisMobile(window.innerWidth < 700);
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        const computePaddingTop = () => { //padding para las modales
            const minWidth = 430;
            const maxWidth = 1024;
            const minPadding = 20;
            const maxPadding = 50;
            const windowWidth = window.innerWidth;

            if (windowWidth <= minWidth) {
                setPaddingTop(`${maxPadding}%`);
            } else if (windowWidth >= maxWidth) {
                setPaddingTop(`${minPadding}%`);
            } else {
                const padding = maxPadding - ((windowWidth - minWidth) / (maxWidth - minWidth)) * (maxPadding - minPadding);
                setPaddingTop(`${padding}%`);
            }
        };

        computePaddingTop();
        window.addEventListener('resize', computePaddingTop);

        return () => {
            window.removeEventListener('resize', computePaddingTop);
        };
    }, []);

    useEffect(() => {
        const fetchPermission = async () => {
            try {
                const waDto = await hasSenderPermissionByTaskMessageTypeAndMessageType(
                    EMessageType.WHATSAPP,
                    ETaskMessageType.STUDY_ORDERS
                );
                setDisabledWhatsapp(!waDto?.hassenderpermission);

                const emailDto = await hasSenderPermissionByTaskMessageTypeAndMessageType(
                    EMessageType.EMAIL,
                    ETaskMessageType.STUDY_ORDERS
                );
                setDisabledEmail(!emailDto?.hassenderpermission);
            } catch (e) {
                setDisabledWhatsapp(true);
                setDisabledEmail(true);
            }
        };

        fetchPermission();
    }, []);

    useEffect(() => {
        if (newRp) {
            if (requestPrescription && !newRp.requestprescription)  //para que en caso de que sea un pedido de receta, primero le de la id del pedido y despues la guarde
                setNewRp({ ...newRp, requestprescription: requestPrescription })
            else
                validateCredential();
        }
    }, [newRp])

    useEffect(() => {
        const genderPatientNull = async () => {
            const genderNull: boolean | null = await isGenderNull(selectedPatient?.medereentity ?? -1)
                .then((res) => {
                    return res
                })
                .catch((error) => {
                    console.error('Error: ', error);
                    return true;
                });
            return genderNull
        };

        const areMinimunFieldsFilled = async () => {
            if (!selectedPatient) return false;
            const { firstname, lastname, document, birthdate } = selectedPatient;
            return (
                firstname !== null && firstname.trim() !== '' &&
                lastname !== null && lastname.trim() !== '' &&
                document !== null && document.trim() !== '' &&
                birthdate !== null &&
                !await genderPatientNull()
            );
        };

        const checkMinimumFields = async () => {
            if (selectedPatient && activeView === ERecipeViews.NEWRECIPE) {
                const result = await areMinimunFieldsFilled();
                setHasMinimunPatientData(result);
            }
        };

        checkMinimumFields()

    }, [selectedPatient])

    useEffect(() => {
        if (recipeResponse && notSuccessfulList) {
            if (notSuccessfulList.length === 0 && hasMinimunPatientData) {
                const pdfList = recipeResponse.map(item => item.recipepdf?.encodedPdf);
                //const pdfPathsList = recipeResponse.map(item => item.recipepdf.pdfFileName);
                setPdfRecipeList(pdfList);
                handleOpenSendModalVisible()
            } else {
                setOpenErrorRecipeValidationModal(true)
            }
        }
    }, [notSuccessfulList])

    useEffect(() => {
        if (!openEditMailModal)
            setNewMail('')
    }, [openEditMailModal])

    useEffect(() => {
        if (!openEditMobilephoneModal)
            setNewMobilephone('')
    }, [openEditMobilephoneModal])

    useEffect(() => {
        if (activeStep === ESteps.CONFIRMATIONSTEP && prevActiveView !== ERecipeViews.PATIENTAGENDA && prevSubActiveView !== EAgendaViews.CREATEPATIENTVIEW && !sendModalVisible) { //Te envía al inicio cuando cerras ventana (!sendModalVisible). El resto es para que no se active el useEffect y no te envie por entrar a la vista o si venis de editar datos del paciente
            clearFieldsAndGoToDashboard()
        }
    }, [sendModalVisible])

    const areAllFieldsFilled = () => {
        const {
            firstname,
            lastname,
            document,
            workenrollmenttype,
            workenrollment,
            attentionplace,
            specialitiesList,
        } = professional;

        return Boolean(
            firstname &&
            lastname &&
            document && document.length > 7 &&
            workenrollmenttype &&
            workenrollment &&
            attentionplace &&
            attentionplace.name &&
            attentionplace.address &&
            attentionplace.city &&
            attentionplace.logo &&
            attentionplace.websiteorsocialmedia &&
            specialitiesList.length > 0
        );
    };

    useEffect(() => {
        setAllProfileDataFilled(areAllFieldsFilled());
    }, [professional]);

    const renderStepContent = () => {
        switch (activeStep) {
            case ESteps.PATIENTSTEP:
                return <PatientStep professionalName={professional?.fulldescription} setSelectedPatient={setSelectedPatient} onValidationChange={setIsStepValid} isStepValid={isStepValid} selectedPatient={selectedPatient} selectedCoverage={selectedCoverage} setSelectedCoverage={setSelectedCoverage} medications={medications} setMedications={setMedications} setProlongedTreatment={setProlongedTreatment} setHidePatientData={setHidePatientData} recipeDate={recipeDate} setRecipeDate={setRecipeDate} handleNext={handleNext} handleBack={handleBack} setActiveView={setActiveView} subActiveView={subActiveView} setSubActiveView={setSubActiveView} prevActiveView={prevActiveView} setPrevActiveView={setPrevActiveView} prevSubActiveView={prevSubActiveView} setPrevSubActiveView={setPrevSubActiveView} setMonthDurationPrescription={setMonthDurationPrescription} />;
            case ESteps.MEDICATIONSTEP:
                return <MedicationStep professionalName={professional?.fulldescription} patient={selectedPatient} selectedCoverage={selectedCoverage} onValidationChange={setIsStepValid} isStepValid={isStepValid} allProfileDataFilled={allProfileDataFilled} medications={medications} setMedications={setMedications} prolongedTreatment={prolongedTreatment} setProlongedTreatment={setProlongedTreatment} hidePatientData={hidePatientData} setHidePatientData={setHidePatientData} diagnosisError={diagnosisError} setDiagnosisError={setDiagnosisError} handleNext={handleNext} handleBack={handleBack} handleGoToEditPatient={handleGoToEditPatient} setActiveView={setActiveView} setSubActiveView={setSubActiveView} setPrevActiveView={setPrevActiveView} setPrevSubActiveView={setPrevSubActiveView} monthDurationPrescription={monthDurationPrescription} setMonthDurationPrescription={setMonthDurationPrescription} />;
            case ESteps.CONFIRMATIONSTEP:
                return <ConfirmationStep professionalName={professional?.fulldescription} patient={selectedPatient} selectedCoverage={selectedCoverage} medications={medications} prolongedTreatment={prolongedTreatment} hidePatientData={hidePatientData} handleNext={handleNext} handleBack={handleBack} recipeDate={recipeDate} setRecipeDate={setRecipeDate} />;
            default:
                return null;
        }
    }

    const renderWarningInsufficientData = () => {
        return professional?.professionaid > 0 && !allProfileDataFilled && (
            <div className='warning-not-filled-data'>
                <Icon icon="mdi:alert" style={{ marginRight: '10px', color: '#FFC107', fontSize: '15px' }} />
                <p style={{ color: '#1E1E1E' }}>Faltan cargar datos del profesional para poder recetar.</p> {isProfessional ? <button type='button' className='labelEdit link-action-button' onClick={handleEditProfile} style={{ marginLeft: '2px', textDecoration: 'underline', color: '#01717C', fontFamily: 'sans-serif', fontStyle: 'italic', background: 'none', border: 'none', padding: 0, cursor: 'pointer' }}>Editar perfil</button> : null}
            </div>
        )
    }

    const handleOpenEditMobilephoneModal = () => {
        if (selectedPatient?.mobilephone) {
            const parsedPhone = validMobileForInputPhone(selectedPatient.mobilephone);
            setPatientPhone(parsedPhone);
            setNewMobilephone(selectedPatient.mobilephone);
        } else {
            setPatientPhone(initialStatePhoneNumber);
            setNewMobilephone('');
        }
        setOpenEditMobilephoneModal(true);
    };

    const handleOpenEditMailModal = () => {
        if (selectedPatient?.email)
            setNewMail(selectedPatient.email)
        setOpenEditMailModal(true)
    }

    const sendDigitalRP = async (messageType: number) => {
        if (messageType === EMessageType.WHATSAPP && disabledWhatsapp) {
            showMessage(toast, "La institución no tiene contratado el envío por WhatsApp.", "warn");
            return;
        }

        if (messageType === EMessageType.EMAIL && disabledEmail) {
            showMessage(toast, "La institución no tiene habilitado el envío por Email.", "warn");
            return;
        }

        if (messageType === EMessageType.WHATSAPP) {
            const number = selectedPatient?.mobilephone;

            if (!number) {
                showMessage(toast, 'Debe ingresar un número de celular.', 'error');
                return;
            }

            const validation = validateInternationalCellphone(number);
            if (!validation.isValid()) {
                showMessage(toast, validation.errorMessage!, 'error');
                return;
            }
        }
        setLoading(true)
        await sendDigitalRpByMessageSender({
            messageTypeId: messageType,
            digitalRpFiles: recipeResponse.map(item => { if (item.success) return item.recipepdf }),
            patientId: selectedPatient?.medereentity ?? -1,
            professionalId: professional.professionaid,
            digitalRpId: null
        }).then((res: ScheduleMessageResponseDTO) => {
            if (res.success) {
                setSendedRecipeModal(true)
            }
            else {
                showMessage(toast, res.message, 'error')
                setViaSended(null)
            }
        }).catch((err) => {
            console.error('Error enviando Rp:', err)
            showMessage(toast, 'Ocurrio un error en el envío', 'error')
            setViaSended(null)
        })
        setLoading(false)
    }

    const handleOpenSendModalVisible = () => {
        console.log(requiresAuditory)
        if (requiresAuditory)
            setOpenAuditoryModal(requiresAuditory)
        else
            setSendModalVisible(!requiresAuditory)

    }

    const handleNext = () => {
        if (isStepValid && allProfileDataFilled) {
            if (activeStep === ESteps.MEDICATIONSTEP) {
                const allMedicationsHaveDiagnosis = medications?.every(med => med.diagnosis && med.diagnosis.trim() !== '');
                if (!allMedicationsHaveDiagnosis) {
                    setDiagnosisError(true)
                    return
                } else
                    setDiagnosisError(false)
            }

            if (activeStep < ESteps.CONFIRMATIONSTEP) {
                setActiveStep(activeStep + 1);
            } else {
                //va al useEffect de newRp
                setNewRp({ patient: selectedPatient, medications: medications ?? [], professional: professional, hidepatientdata: hidePatientData, starteddate: recipeDate ? new Date(recipeDate) : new Date(), servicedate: null, issueasparticular: !selectedPatient?.insurances || selectedPatient.insurances?.length <= 0 ? true : null, requestprescription: null, generaldiagnosis: '-', prolongedtreatment: prolongedTreatment, observations: '', monthdurationprescription: monthDurationPrescription.months })
            }
        }
    };

    const handleBack = () => {
        if (activeStep === ESteps.MEDICATIONSTEP && (prevActiveView === 0 || (prevActiveView === ERecipeViews.RECIPEHISTORY && prevSubActiveView === ERecipeHistoryTab.PENDING))) {
            setOpenHandleBackFromMedicationStepModal(true)
            return
        }

        if (activeStep === subActiveView && ((prevActiveView && prevSubActiveView) || (prevActiveView === 0 && prevSubActiveView === 0))) {
            setMedications([])
            setSubActiveView(prevSubActiveView)
            setPrevSubActiveView(undefined)
            setActiveView(prevActiveView)
            setPrevActiveView(undefined)
        } else
            if (activeStep > ESteps.PATIENTSTEP)
                setActiveStep(activeStep - 1);
            else {
                setSelectedPatient(null)
                setMedications([])
                setSubActiveView(0),
                    setActiveView(0)
            }
    };

    const validateCredential = async () => {
        setLoading(true)
        const handleSuccess = (res: RecipeResponseDTO[]) => {
            if (successfulList) {   //successfulList solo es no null cuando se emite como particular en handleEmitionAsParticular
                setRecipeResponse(res.concat(successfulList))
                setSuccessfulList(null)
            } else {
                setRecipeResponse(res)
            }

            const notSuccessList: RecipeResponseDTO[] = res.filter(item => !item.success);
            setNotSuccessfulList(notSuccessList) //va al useEffect de notSuccessfulList
            setLoading(false)
        }
        const handleError = (error: any) => {
            setLoading(false)
            console.error('Error guardando Rp:', error)
            showLongMessage(toast, 'Se produjo un error inesperado. Intentá actualizar la página y realizarlo nuevamente en unos minutos.', 'error')
        }

        if (!newRp.requestprescription) { //es una receta
            await saveDigitalRp(newRp)
                .then((res: RecipeAuditoryResponseDTO[]) => { handleSuccess(res[0].recipeResponseDTO), setRequiresAuditory(res[0].requiresauditory) })
                .catch(error => { handleError(error) });
        } else { //es de un pedido de receta
            await saveDigitalRpRequested(newRp)
                .then((res: RecipeResponseDTO[]) => { handleSuccess(res) })
                .catch(error => { handleError(error) });
        }
    };

    useEffect(() => {
        if (!openAuditoryModal && activeStep === ESteps.CONFIRMATIONSTEP && prevActiveView !== ERecipeViews.PATIENTAGENDA && prevSubActiveView !== EAgendaViews.CREATEPATIENTVIEW && !sendModalVisible) { //Te envía al inicio cuando cerras ventana (!sendModalVisible). El resto es para que no se active el useEffect y no te envie por entrar a la vista o si venis de editar datos del paciente
            clearFieldsAndGoToDashboard()
        }
    }, [openAuditoryModal])

    const handleGoToEditPatient = () => {
        setPrevSubActiveView(ESteps.MEDICATIONSTEP)
        setPrevActiveView(ERecipeViews.NEWRECIPE)
        setSubActiveView(EAgendaViews.CREATEPATIENTVIEW)
        setActiveView(ERecipeViews.PATIENTAGENDA)
    }

    const clearFieldsAndGoToDashboard = () => {
        setSelectedPatient(null)
        setMedications([])
        setProlongedTreatment(false)
        setHidePatientData(false)
        setSendModalVisible(false)
        setCancelModalVisible(false)
        setRefreshPending(true)
        setMonthDurationPrescription({ months: 1, description: '1 mes' })
        setPrevSubActiveView(undefined)
        setPrevActiveView(undefined)
        setSubActiveView(0),
            setActiveView(0)
    }

    const handleReviewPatientData = () => {
        setPrevActiveView(ERecipeViews.NEWRECIPE)
        setPrevSubActiveView(ESteps.CONFIRMATIONSTEP)
        setSubActiveView(EAgendaViews.CREATEPATIENTVIEW)
        setActiveView(ERecipeViews.PATIENTAGENDA)
        setOpenErrorRecipeValidationModal(false);
    };

    const handleEditProfile = () => {
        setErrorProfileDataFields(true)
        setPrevSubActiveView(ESteps.MEDICATIONSTEP)
        setPrevActiveView(ERecipeViews.NEWRECIPE)
        setSubActiveView(EProfileDataViews.PROFILEDATAFORMVIEW)
        setActiveView(ERecipeViews.PROFILEDATA)
    }

    const handleEmitionAsParticular = () => {

        let updatedMedications: Medicine[] = [];

        notSuccessfulList?.forEach(item => {
            updatedMedications = [...updatedMedications, ...item.medicinePrescripted];
        });

        const successList: RecipeResponseDTO[] = recipeResponse.filter(item => item.success);
        setSuccessfulList(successList) //las guardo para cuando me devuelva las particulares

        setNewRp({ ...newRp, medications: updatedMedications, issueasparticular: true, patient: newRp?.patient, professional: newRp?.professional, hidepatientdata: newRp?.hidepatientdata ?? false, starteddate: newRp?.starteddate ?? new Date(), servicedate: newRp?.servicedate ?? new Date(), requestprescription: newRp?.requestprescription ?? null, generaldiagnosis: newRp?.generaldiagnosis ?? '', prolongedtreatment: newRp?.prolongedtreatment ?? false, observations: newRp?.observations ?? '', monthdurationprescription: newRp?.monthdurationprescription ?? 1 }) //va al useEffect de newRp
        setOpenErrorRecipeValidationModal(false)

    };


    //TODO: Refactorizar pdfs
    const handleDownloadPdfs = () => {
        pdfRecipeList.forEach((pdf, index) => {
            const byteCharacters = atob(pdf);
            const byteNumbers = new Uint8Array(byteCharacters.length);

            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }

            const blob = new Blob([byteNumbers], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `receta_${index + 1}.pdf`;

            document.body.appendChild(a);
            a.click();

            setTimeout(() => {
                window.URL.revokeObjectURL(url);
                document.body.removeChild(a);
            }, 0);
        });
    };

    const handleShare = async () => {
        try {
            const filesToShare = pdfRecipeList.map((pdf, index) => {
                const byteCharacters = atob(pdf);
                const byteNumbers = new Uint8Array(byteCharacters.length);

                for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }

                const blob = new Blob([byteNumbers], { type: 'application/pdf' });

                return new File([blob], `receta_${index + 1}.pdf`, { type: 'application/pdf' });
            });

            if (navigator.canShare && navigator.canShare({ files: filesToShare })) {
                await navigator.share({
                    files: filesToShare,
                    title: 'Recetas Médicas',
                    text: 'Aquí tienes tus recetas en PDF.',
                });
            } else {
                console.warn('La API de compartir no es compatible en este dispositivo.');
            }
        } catch (error) {
            console.error('Error al compartir los PDFs:', error);
        }
    };

    return (
        <div className="new-recipe-view">
            {isMobile ?
                <div>
                    {renderWarningInsufficientData()}
                    <div style={{ paddingLeft: '15px', paddingRight: '15px', paddingTop: '15px' }}>
                        <h1 style={{ marginLeft: '8px', marginTop: '8px', marginBottom: '3px', fontWeight: 600 }}>Nueva receta</h1>
                        <div style={{ marginTop: '-3px' }} className="cards-container">
                            <Steps steps={steps} activeStep={activeStep} stepWidth='100%' shift style={{ marginBottom: '1.5rem', marginTop: '1.3rem' }} labelStyle={{ color: '#1C324F' }} />
                            {renderStepContent()}
                        </div>
                    </div>

                    <div style={{ boxShadow: '0px -4px 16px 0px rgba(0, 0, 0, 0.15)' }}>
                        <div style={{ padding: '15px', display: 'flex', flexDirection: 'column' }}>
                            <Button
                                label={activeStep === ESteps.CONFIRMATIONSTEP ? "Finalizar receta" : "Continuar"}
                                onClick={handleNext}
                                disabled={!isStepValid || (activeStep === ESteps.CONFIRMATIONSTEP ? !allProfileDataFilled : false)}
                                style={{ marginBottom: '15px', backgroundColor: (isStepValid && allProfileDataFilled) ? '#14C7BC' : '#9E9E9E', border: 'none', height: '36px' }}
                            />
                            <Button
                                label={activeStep === ESteps.CONFIRMATIONSTEP ? "Hacer cambios" : (activeStep === ESteps.MEDICATIONSTEP ? "Volver" : "Cancelar receta")}
                                onClick={handleBack}
                                style={{ backgroundColor: '#FFFFFF', color: '#545454', height: '36px', border: '1px solid #3CB8BA' }}
                            />
                        </div>
                    </div>
                </div>
                :
                <div style={{ overflowY: 'hidden' }}>
                    <div style={{ minWidth: '137px' }}>
                        {renderWarningInsufficientData()}
                        <h1 style={{ marginLeft: '8px', marginTop: '8px', marginBottom: '3px', fontWeight: 600 }}>Nueva receta</h1>
                    </div>
                    <div>
                        <div style={{ paddingLeft: '50px', height: 'fit-content', overflowY: 'hidden', overflowX: 'hidden' }}>
                            <Steps steps={steps} activeStep={activeStep} stepWidth='29%' shift style={{ marginBottom: '1.5rem' }} labelStyle={{ color: '#1C324F' }} />
                            {renderStepContent()}
                        </div>
                    </div>
                </div>
            }

            {isMobile ?

                <div>
                    <Modal
                        visible={openAuditoryModal}
                        setVisible={setOpenAuditoryModal}
                        className="h-full"
                    >
                        <div className="modal-body">
                            La receta está pendiente de auditoría
                        </div>
                    </Modal>
                    <Modal
                        visible={sendModalVisible}
                        setVisible={setSendModalVisible}
                        closable={false}
                        className="h-full"
                    >
                        <div className="modal-body">

                            {(recipeResponse && pdfRecipeList.length > 0) ?
                                <div>
                                    <PdfViewer fileList={pdfRecipeList} />
                                </div> : null
                            }

                            <hr style={{ marginTop: '20px' }} />

                            <h3 style={{ marginTop: '20px', marginBottom: '10px', fontSize: '18px' }}><strong>{"Enviar al paciente"}</strong></h3>

                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                                    <Button
                                        icon={<Icon icon='bi:chat' style={{ color: '#FFFFFF', marginRight: '10px', fontSize: '18px' }} />}
                                        label={"Por whatsapp a " + (selectedPatient?.mobilephone ? selectedPatient.mobilephone : '')}
                                        className='font-size-sendButton'
                                        onClick={() => { sendDigitalRP(EMessageType.WHATSAPP), setViaSended(EMessageType.WHATSAPP) }}
                                        style={{ backgroundColor: '#14C7BC', border: 'none', color: '#FFFFFF', textAlign: 'left', flexGrow: 1 }}
                                        disabled={disabledWhatsapp || !selectedPatient?.mobilephone}
                                    />
                                    <Button
                                        icon={<Icon icon={selectedPatient?.mobilephone ? 'bi:pencil-square' : 'bi:plus'} style={{ color: '#01717C', fontSize: selectedPatient?.mobilephone ? '19px' : '24px' }} />}
                                        onClick={handleOpenEditMobilephoneModal}
                                        style={{ backgroundColor: '#DBDFE5', color: '#01717C', border: 'none', borderRadius: '100px', marginLeft: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center', width: '35px', height: '35px' }}
                                        disabled={disabledWhatsapp}
                                    />
                                </div>
                                {disabledWhatsapp && (
                                    <small style={{ color: '#FFB400', display: 'block', marginTop: '-5px', marginBottom: '5px', textAlign: 'right' }}>
                                        <i className="pi pi-exclamation-triangle" style={{ marginRight: '5px' }}></i>
                                        <label style={{ color: '#757575' }}>Servicio con costo adicional. </label><a href={`https://wa.me/${customerServiceNumber}?text=${whatsappPurchaseText}`} target="_blank" style={{ textDecoration: 'underline', color: '#01717C', fontFamily: 'sans-serif', fontStyle: 'italic' }}>Contratar ahora</a>
                                    </small>
                                )}

                                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                                    <Button
                                        icon={<Icon icon='bi:envelope' style={{ color: '#FFFFFF', marginRight: '10px', fontSize: '18px' }} />}
                                        label={"A " + (selectedPatient?.email ? selectedPatient.email : '')}
                                        className='font-size-sendButton'
                                        onClick={() => { sendDigitalRP(EMessageType.EMAIL), setViaSended(EMessageType.EMAIL) }}
                                        style={{ backgroundColor: '#14C7BC', border: 'none', color: '#FFFFFF', textAlign: 'left', flexGrow: 1 }}
                                        disabled={disabledEmail || !selectedPatient?.email}
                                    />
                                    <Button
                                        icon={<Icon icon={selectedPatient?.email ? 'bi:pencil-square' : 'bi:plus'} style={{ color: '#01717C', fontSize: selectedPatient?.email ? '19px' : '24px' }} />}
                                        onClick={handleOpenEditMailModal}
                                        style={{ backgroundColor: '#DBDFE5', color: '#01717C', border: 'none', borderRadius: '100px', marginLeft: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center', width: '35px', height: '35px' }}
                                        disabled={disabledEmail}
                                    />
                                </div>

                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <Button
                                        icon={<Icon icon='bi:download' style={{ color: '#3CB8BA', marginRight: '10px', fontSize: '18px' }} />}
                                        label={"Descargar receta"}
                                        className='font-size-sendButton'
                                        onClick={handleDownloadPdfs}
                                        style={{ backgroundColor: '#FFFFFF', color: '#292929', textAlign: 'left', marginBottom: '10px', borderColor: '#3CB8BA' }}
                                    />
                                    <Button
                                        icon={<Icon icon='bi:send' style={{ color: '#3CB8BA', marginRight: '10px', fontSize: '18px' }} />}
                                        label={"Compartir por otros medios"}
                                        className='font-size-sendButton'
                                        onClick={() => { handleShare() }}
                                        style={{ backgroundColor: '#FFFFFF', color: '#292929', textAlign: 'left', marginBottom: '30px', borderColor: '#3CB8BA' }}
                                    />
                                </div>

                                <Button
                                    label="Cancelar"
                                    onClick={() => { setCancelModalVisible(true) }}
                                    style={{ marginBottom: '15px', backgroundColor: '#E8EBEF', color: '#1E1E1E', border: 'none', height: '36px' }}
                                />
                            </div>
                        </div>
                    </Modal>

                    <Modal
                        visible={openEditMobilephoneModal}
                        setVisible={setOpenEditMobilephoneModal}
                        header={<div style={{ display: 'flex', flexDirection: 'column', textAlign: 'center', paddingTop: paddingTop, paddingLeft: '10%' }}>
                            <strong>{selectedPatient?.mobilephone ? "Editar celular del paciente" : "Ingresar celular del paciente"}</strong>
                        </div>}
                        headerStyle={{ fontSize: '12px', textAlign: 'center' }}
                        className='h-full'
                    >
                        <div className='new-recipe-view' style={{ display: 'flex', flexDirection: 'column' }}>
                            <label style={{ color: '#1E1E1E', fontSize: '14px', marginBottom: '1rem' }}>El cambio de la información se actualizará en la base de datos del paciente.</label>
                            <label style={{ color: '#1E1E1E', fontSize: '14px' }}>Celular</label>
                            <InputPhone
                                cboClassname='border2 w-4'
                                inputClassname='border2'
                                value={patientPhone}
                                label="Característica sin 0 y número sin 15. (Ejemplo: 2231234567)"
                                floatLabel={false}
                                setValue={(mobile) => {
                                    setPatientPhone(mobile);
                                    setNewMobilephone(mobilePhoneToString(mobile));
                                }}
                            />
                            <Button
                                label={selectedPatient?.mobilephone ? "Cambiar" : "Agregar"}
                                onClick={() => {
                                    const validation = validateInternationalCellphone(newMobilephone);

                                    if (!validation.isValid()) {
                                        showMessage(toast, validation.errorMessage!, 'error');
                                        return;
                                    }

                                    if (selectedPatient) {
                                        setSelectedPatient({ ...selectedPatient, mobilephone: newMobilephone.replace(/[^+\d]/g, '') })
                                        savePatient({ ...selectedPatient, mobilephone: newMobilephone }, 0, 0)
                                            .then(() => {
                                                showMessage(toast, 'Datos guardados', 'success')
                                            })
                                            .catch(() => {
                                                showMessage(toast, 'Error al guardar el celular', 'error')
                                            });
                                        setOpenEditMobilephoneModal(false)
                                    }
                                }}
                                style={{ marginTop: '8px', backgroundColor: (newMobilephone?.trim() !== '' && !/^[A-Za-z]+$/.test(newMobilephone)) ? '#14C7BC' : '#9E9E9E', border: 'none' }}
                                disabled={newMobilephone?.trim() === '' || /^[A-Za-z]+$/.test(newMobilephone)}
                            />
                        </div>
                    </Modal>

                    <Modal
                        visible={openEditMailModal}
                        setVisible={setOpenEditMailModal}
                        header={<div style={{ display: 'flex', flexDirection: 'column', textAlign: 'center', paddingTop: paddingTop, paddingLeft: '10%' }}>
                            <strong>{selectedPatient?.email ? "Editar mail del paciente" : "Ingresar mail del paciente"}</strong>
                        </div>}
                        headerStyle={{ fontSize: '12px', textAlign: 'center' }}
                        className='h-full'
                    >
                        <div className='new-recipe-view' style={{ display: 'flex', flexDirection: 'column' }}>
                            <label style={{ color: '#1E1E1E', fontSize: '14px', marginBottom: '1rem' }}>El cambio de la información se actualizará en la base de datos del paciente.</label>
                            <label style={{ color: '#1E1E1E', fontSize: '14px' }}>Mail</label>
                            <InputTextCustom
                                className="border2"
                                name="email"
                                value={newMail}
                                onChange={(e: any) => {
                                    setNewMail(e.target.value);
                                }}
                            />
                            <Button
                                label={selectedPatient?.email ? "Cambiar" : "Agregar"}
                                onClick={() => {
                                    if (selectedPatient) {
                                        if (setSelectedPatient) {
                                            setSelectedPatient({ ...selectedPatient, email: newMail })
                                            savePatient({ ...selectedPatient, email: newMail }, 0, 0)
                                                .then(() => {
                                                    showMessage(toast, 'Datos guardados', 'success')
                                                })
                                                .catch(() => {
                                                    showMessage(toast, 'Error al guardar el mail', 'error')
                                                });
                                            setOpenEditMailModal(false)
                                        }
                                    }
                                }}
                                style={{ marginTop: '8px', backgroundColor: newMail?.trim() !== '' ? '#14C7BC' : '#9E9E9E', border: 'none' }}
                                disabled={newMail?.trim() === ''}
                            />
                        </div>
                    </Modal>
                </div>
                :
                <div>
                    <Modal
                        visible={openAuditoryModal}
                        setVisible={setOpenAuditoryModal}
                        className="h-full"
                    >
                        <div className="modal-body">
                            La receta está pendiente de auditoría
                        </div>
                    </Modal>
                    <Modal
                        visible={sendModalVisible}
                        setVisible={setSendModalVisible}
                        header={<h1 style={{ fontSize: '20px', color: '#B67345' }}>Receta</h1>}
                        closable={false}
                        width='w-2xlarge'
                    >
                        <div className="modal-body" style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', overflowX: 'scroll', overflowY: 'hidden' }}>
                            <div style={{ flex: '1', marginRight: '2rem' }}>
                                {(recipeResponse && pdfRecipeList.length > 0) ?
                                    <div>
                                        <PdfViewer fileList={pdfRecipeList} />
                                    </div> : null
                                }
                            </div>

                            <div style={{ flex: '1', borderLeft: '4px solid rgba(28, 50, 79, 0.38)', paddingLeft: '1rem', paddingRight: '1rem', marginBottom: '1rem', height: 'fit-content', maxHeight: '450px', overflowY: 'scroll', minWidth: 'fit-content' }}>
                                <h3 style={{ marginTop: '20px', marginBottom: '10px', fontSize: '18px' }}><strong>{"Enviar al paciente"}</strong></h3>

                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                                        <Button
                                            icon={<Icon icon='bi:chat' style={{ color: '#FFFFFF', marginRight: '10px', fontSize: '18px' }} />}
                                            label={"Por whatsapp a " + (selectedPatient?.mobilephone ? selectedPatient.mobilephone : '')}
                                            className='font-size-sendButton btnRpBack'
                                            onClick={() => { sendDigitalRP(EMessageType.WHATSAPP), setViaSended(EMessageType.WHATSAPP) }}
                                            style={{ backgroundColor: '#14C7BC', border: 'none', color: '#FFFFFF', textAlign: 'left', flexGrow: 1, minWidth: 'fit-content' }}
                                            disabled={disabledWhatsapp || !selectedPatient?.mobilephone}
                                        />
                                        <Button
                                            className='btnRpBack'
                                            icon={<Icon icon={selectedPatient?.mobilephone ? 'bi:pencil-square' : 'bi:plus'} style={{ color: '#01717C', fontSize: selectedPatient?.mobilephone ? '19px' : '24px' }} />}
                                            onClick={handleOpenEditMobilephoneModal}
                                            style={{ backgroundColor: '#DBDFE5', color: '#01717C', border: 'none', borderRadius: '100px', marginLeft: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center', width: '35px', height: '35px' }}
                                            disabled={disabledWhatsapp}
                                        />
                                    </div>
                                    {disabledWhatsapp && (
                                        <small style={{ color: '#FFB400', display: 'block', marginTop: '-5px', marginBottom: '5px', textAlign: 'right' }}>
                                            <i className="pi pi-exclamation-triangle" style={{ marginRight: '5px' }}></i>
                                            <label style={{ color: '#757575' }}>Servicio con costo adicional. </label><a href={`https://wa.me/${customerServiceNumber}?text=${whatsappPurchaseText}`} target="_blank" style={{ textDecoration: 'underline', color: '#01717C', fontFamily: 'sans-serif', fontStyle: 'italic' }}>Contratar ahora</a>
                                        </small>
                                    )}

                                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                                        <Button
                                            icon={<Icon icon='bi:envelope' style={{ color: '#FFFFFF', marginRight: '10px', fontSize: '18px' }} />}
                                            label={"A " + (selectedPatient?.email ? selectedPatient.email : '')}
                                            className='font-size-sendButton btnRpBack'
                                            onClick={() => { sendDigitalRP(EMessageType.EMAIL), setViaSended(EMessageType.EMAIL) }}
                                            style={{ backgroundColor: '#14C7BC', border: 'none', color: '#FFFFFF', textAlign: 'left', flexGrow: 1, minWidth: 'fit-content' }}
                                            disabled={disabledEmail || !selectedPatient?.email}
                                        />
                                        <Button
                                            className='btnRpBack'
                                            icon={<Icon icon={selectedPatient?.email ? 'bi:pencil-square' : 'bi:plus'} style={{ color: '#01717C', fontSize: selectedPatient?.email ? '19px' : '24px' }} />}
                                            onClick={handleOpenEditMailModal}
                                            style={{ backgroundColor: '#DBDFE5', color: '#01717C', border: 'none', borderRadius: '100px', marginLeft: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center', width: '35px', height: '35px' }}
                                            disabled={disabledEmail}
                                        />
                                    </div>

                                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                                        <Button
                                            icon={<Icon icon='bi:download' style={{ color: '#3CB8BA', marginRight: '10px', fontSize: '18px' }} />}
                                            label={"Descargar receta"}
                                            className='font-size-sendButton btnRpBack'
                                            onClick={handleDownloadPdfs}
                                            style={{ backgroundColor: '#FFFFFF', color: '#292929', textAlign: 'left', marginBottom: '10px', borderColor: '#3CB8BA' }}
                                        />
                                        <Button
                                            icon={<Icon icon='bi:send' style={{ color: '#3CB8BA', marginRight: '10px', fontSize: '18px' }} />}
                                            label={"Compartir por otros medios"}
                                            className='font-size-sendButton btnRpBack'
                                            onClick={() => { handleShare() }}
                                            style={{ backgroundColor: '#FFFFFF', color: '#292929', textAlign: 'left', marginBottom: '30px', borderColor: '#3CB8BA' }}
                                        />
                                    </div>

                                    <Button
                                        className='btnRpBack'
                                        label="Cancelar"
                                        onClick={() => { setCancelModalVisible(true) }}
                                        style={{ marginBottom: '15px', backgroundColor: '#E8EBEF', color: '#1E1E1E', border: 'none', height: '36px' }}
                                    />
                                </div>
                            </div>
                        </div>
                    </Modal>

                    <Modal
                        visible={openEditMobilephoneModal}
                        setVisible={setOpenEditMobilephoneModal}
                        header={<div style={{ display: 'flex', flexDirection: 'column', textAlign: 'left' }}>
                            <strong>{selectedPatient?.mobilephone ? "Editar celular del paciente" : "Ingresar celular del paciente"}</strong>
                        </div>}
                        headerStyle={{ fontSize: '12px', textAlign: 'center' }}
                        width='w-medium'
                    >
                        <div className='new-recipe-view' style={{ display: 'flex', flexDirection: 'column' }}>
                            <label style={{ color: '#1E1E1E', fontSize: '14px', marginBottom: '1rem' }}>El cambio de la información se actualizará en la base de datos del paciente.</label>
                            <label style={{ color: '#1E1E1E', fontSize: '14px' }}>Celular</label>
                            <InputPhone
                                cboClassname='border2 w-4'
                                inputClassname='border2'
                                value={patientPhone}
                                label="Característica sin 0 y número sin 15. (Ejemplo: 2231234567)"
                                floatLabel={false}
                                setValue={(mobile) => {
                                    setPatientPhone(mobile);
                                    setNewMobilephone(mobilePhoneToString(mobile));
                                }}
                            />
                            <Button
                                label={selectedPatient?.mobilephone ? "Cambiar" : "Agregar"}
                                onClick={() => {
                                    const validation = validateInternationalCellphone(newMobilephone);

                                    if (!validation.isValid()) {
                                        showMessage(toast, validation.errorMessage!, 'error');
                                        return;
                                    }

                                    if (selectedPatient) {
                                        setSelectedPatient({ ...selectedPatient, mobilephone: newMobilephone.replace(/[^+\d]/g, '') })

                                        savePatient({ ...selectedPatient, mobilephone: newMobilephone }, 0, 0)
                                            .then(() => {
                                                showMessage(toast, 'Datos guardados', 'success')
                                            })
                                            .catch(() => {
                                                showMessage(toast, 'Error al guardar el celular', 'error')
                                            });
                                        setOpenEditMobilephoneModal(false)
                                    }
                                }}
                                style={{ marginTop: '8px', backgroundColor: (newMobilephone?.trim() !== '' && !/^[A-Za-z]+$/.test(newMobilephone)) ? '#14C7BC' : '#9E9E9E', border: 'none' }}
                                disabled={newMobilephone?.trim() === '' || /^[A-Za-z]+$/.test(newMobilephone)}
                            />
                        </div>
                    </Modal>

                    <Modal
                        visible={openEditMailModal}
                        setVisible={setOpenEditMailModal}
                        header={<div style={{ display: 'flex', flexDirection: 'column', textAlign: 'left' }}>
                            <strong>{selectedPatient?.email ? "Editar mail del paciente" : "Ingresar mail del paciente"}</strong>
                        </div>}
                        headerStyle={{ fontSize: '12px', textAlign: 'center' }}
                        width='w-medium'
                    >
                        <div className='new-recipe-view' style={{ display: 'flex', flexDirection: 'column' }}>
                            <label style={{ color: '#1E1E1E', fontSize: '14px', marginBottom: '1rem' }}>El cambio de la información se actualizará en la base de datos del paciente.</label>
                            <label style={{ color: '#1E1E1E', fontSize: '14px' }}>Mail</label>
                            <InputTextCustom
                                className="border2"
                                name="email"
                                value={newMail}
                                onChange={(e: any) => {
                                    setNewMail(e.target.value);
                                }}
                            />
                            <Button
                                label={selectedPatient?.email ? "Cambiar" : "Agregar"}
                                onClick={() => {
                                    if (setSelectedPatient) {
                                        setSelectedPatient({ ...selectedPatient, email: newMail })
                                        savePatient({ ...selectedPatient, email: newMail }, 0, 0)
                                            .then(() => {
                                                showMessage(toast, 'Datos guardados', 'success')
                                            })
                                            .catch(() => {
                                                showMessage(toast, 'Error al guardar el mail', 'error')
                                            });
                                        setOpenEditMailModal(false)
                                    }
                                }}
                                style={{ marginTop: '8px', backgroundColor: newMail?.trim() !== '' ? '#14C7BC' : '#9E9E9E', border: 'none' }}
                                disabled={newMail?.trim() === ''}
                            />
                        </div>
                    </Modal>
                </div>
            }

            <Modal
                visible={cancelModalVisible}
                setVisible={setCancelModalVisible}
                header={<label><strong>¿Querés cancelar el envío de esta receta?</strong></label>}
                headerStyle={{ fontSize: '12px', textAlign: 'center', paddingTop: paddingTop }}
                closable={false}
                className='h-full'
            >
                <div style={{ textAlign: 'center', display: 'flex', flexDirection: 'column' }}>
                    <Button
                        label="No, quiero enviar la receta"
                        onClick={() => setCancelModalVisible(false)}
                        style={{ backgroundColor: '#FFFFFF', color: '#545454', border: '1px solid #3CB8BA', marginBottom: '15px' }}
                    />
                    <Button
                        label="Sí, salir sin enviar"
                        onClick={clearFieldsAndGoToDashboard}
                        style={{ backgroundColor: '#14C7BC', border: 'none' }}
                    />
                </div>
            </Modal>

            <Modal
                visible={sendedRecipeModal}
                setVisible={setSendedRecipeModal}
                header={<div style={{ display: 'flex', flexDirection: 'column', textAlign: 'center' }}><i className="pi pi-check" style={{ fontSize: '48px', color: '#A53E2B' }}></i>
                    <label style={{ marginTop: '10px' }}><strong>¡La receta fue enviada!</strong></label></div>}
                headerStyle={{ fontSize: '12px', textAlign: 'center', paddingTop: paddingTop }}
                closable={false}
                className='h-full'
            >
                <div style={{ display: 'flex', flexDirection: 'column', textAlign: 'center' }}>
                    {(viaSended === EMessageType.EMAIL || viaSended === EMessageType.WHATSAPP) ?
                        <label style={{ color: '#1E1E1E', fontSize: '14px', marginBottom: '1rem' }}>El paciente {selectedPatient?.firstname + " " + selectedPatient?.lastname} lo recibirá en: {viaSended === EMessageType.EMAIL ? selectedPatient?.email : selectedPatient?.mobilephone}</label>
                        :
                        <label style={{ color: '#1E1E1E', fontSize: '14px', marginBottom: '1rem' }}>El paciente {selectedPatient?.firstname + " " + selectedPatient?.lastname} lo recibirá por el medio enviado</label> //por si se envía por la opción de otros medios
                    }
                    <Button
                        label="Finalizar"
                        onClick={() => {
                            setSendedRecipeModal(false)
                            setSendModalVisible(false) //va al useEffect de sendModal, que limpia todo y vuelve al dashboard
                        }}
                        style={{ backgroundColor: '#14C7BC', border: 'none', marginBottom: '15px' }}
                    />
                    <Button
                        label="Reenviar por otro medio"
                        onClick={() => setSendedRecipeModal(false)}
                        style={{ backgroundColor: '#FFFFFF', color: '#545454', border: '1px solid #3CB8BA' }}
                    />
                </div>
            </Modal>

            <Modal
                visible={openHandleBackFromMedicationStepModal}
                setVisible={setOpenHandleBackFromMedicationStepModal}
                header={<div style={{ display: 'flex', flexDirection: 'column', textAlign: 'center' }}><i className="pi pi-exclamation-circle" style={{ fontSize: '48px', color: '#A53E2B' }}></i>
                    <label style={{ marginTop: '10px' }}><strong>¿Quieres volver a la pantalla anterior?</strong></label></div>}
                headerStyle={{ fontSize: '12px', textAlign: 'center', paddingTop: paddingTop }}
                closable={false}
                className='h-full'
            >
                <div style={{ display: 'flex', flexDirection: 'column', textAlign: 'center' }}>
                    <Button
                        label="Sí, quiero volver"
                        onClick={() => {
                            setOpenHandleBackFromMedicationStepModal(false)
                            if (activeStep === subActiveView && ((prevActiveView && prevSubActiveView) || (prevActiveView === 0 && prevSubActiveView === 0))) {
                                setMedications([])
                                setSelectedPatient(null)
                                setSubActiveView(prevSubActiveView)
                                setPrevSubActiveView(undefined)
                                setActiveView(prevActiveView)
                                setPrevActiveView(undefined)
                            } else
                                if (activeStep > ESteps.PATIENTSTEP)
                                    setActiveStep(activeStep - 1);
                                else {
                                    setSelectedPatient(null)
                                    setMedications([])
                                    setSubActiveView(0),
                                        setActiveView(0)
                                }
                        }}
                        style={{ marginBottom: '15px', backgroundColor: '#14C7BC', border: 'none' }}
                    />
                    <Button
                        label="Quedarse"
                        onClick={() => { setOpenHandleBackFromMedicationStepModal(false) }}
                        style={{ marginBottom: '15px', backgroundColor: '#FFFFFF', color: '#545454', border: '1px solid #14C7BC' }}
                    />
                </div>
            </Modal>

            <Modal
                visible={openErrorRecipeValidationModal}
                setVisible={setOpenErrorRecipeValidationModal}
                header={<div style={{ display: 'flex', flexDirection: 'column', textAlign: 'center', paddingLeft: '10%' }}><i className="pi pi-exclamation-circle" style={{ fontSize: '48px', color: '#A53E2B' }}></i>
                    <label style={{ marginTop: '10px' }}><strong>{hasMinimunPatientData ? "La obra social no pudo validar la receta" : "Datos insuficientes"}</strong></label></div>}
                headerStyle={{ fontSize: '12px', textAlign: 'center', paddingTop: !hasMinimunPatientData && isMobile ? paddingTop : '' }}
                className={!hasMinimunPatientData && isMobile ? 'h-full' : ''}
                width='w-medium'
            >
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <label style={{ fontSize: '14px' }}><strong>{hasMinimunPatientData ? "Motivo de error: " : ""}</strong>{hasMinimunPatientData ? (notSuccessfulList && notSuccessfulList.length > 0 ? notSuccessfulList[0].message : "") : "Para recetar necesitás completar algunos datos del paciente."}
                    </label>
                    {notSuccessfulList?.map((notsuccess: RecipeResponseDTO) => (
                        <ul style={{ listStyleType: 'disc', paddingLeft: '20px' }}>
                            {notsuccess.medicinePrescripted.map((med: Medicine, index) => (
                                <li key={index} style={{ marginBottom: '10px', fontSize: '14px' }}>
                                    <div>{(med.issubstance ? med.drugdescription : med.medicinalproductdescription) + " " + med.presentationdescription}</div>
                                </li>
                            ))}
                        </ul>
                    ))}

                    {!hasMinimunPatientData || recipeResponse?.every(recipe => !recipe.success) ? null :
                        <div>
                            <strong style={{ fontSize: '14px' }}>Medicamentos validados</strong>
                            {recipeResponse.map((item: RecipeResponseDTO, recipeIndex) => (
                                item.success ? (
                                    <ul key={`recipe-${recipeIndex}`} style={{ listStyleType: 'disc', paddingLeft: '20px' }}>
                                        {item.medicinePrescripted.map((med: Medicine) => (
                                            <li
                                                key={med.drugdescription + med.presentationdescription}
                                                style={{ marginBottom: '10px', fontSize: '14px' }}
                                            >
                                                <div>
                                                    {(med.issubstance
                                                        ? med.drugdescription
                                                        : med.medicinalproductdescription
                                                    ) + " " + med.presentationdescription}
                                                </div>
                                            </li>
                                        ))}
                                    </ul>
                                ) : null
                            ))}
                        </div>
                    }


                    <div style={{ display: 'flex', flexDirection: 'column', textAlign: 'center' }}>
                        <Button
                            label="Revisar los datos del paciente"
                            onClick={handleReviewPatientData}
                            style={{ marginBottom: '15px', backgroundColor: '#14C7BC', border: 'none', marginTop: !hasMinimunPatientData ? '10px' : '""' }}
                        />
                        {hasMinimunPatientData ? <>
                            <Button
                                label="Revisar medicamentos agregados"
                                onClick={() => {
                                    handleBack()
                                    setOpenErrorRecipeValidationModal(false)
                                }}
                                style={{ marginBottom: '15px', backgroundColor: '#FFFFFF', color: '#545454', border: '1px solid #14C7BC' }}
                            />
                            <Button
                                label="Realizar la receta sin cobertura"
                                onClick={handleEmitionAsParticular}
                                style={{ marginBottom: '15px', backgroundColor: '#FFFFFF', color: '#545454', border: '1px solid #14C7BC' }}
                            />
                            {recipeResponse.every(recipe => !recipe.success) ? null :
                                <Button
                                    label={"Recetar los medicamentos validados"}
                                    onClick={() => {
                                        const pdfList: any = recipeResponse.map(item => { if (item.success) return item.recipepdf.encodedPdf });
                                        setPdfRecipeList(pdfList);

                                        handleOpenSendModalVisible()
                                        setOpenErrorRecipeValidationModal(false)
                                    }}
                                    style={{ marginBottom: '15px', backgroundColor: '#FFFFFF', color: '#545454', border: '1px solid #14C7BC' }}
                                />
                            }</> : null
                        }
                    </div>
                </div>
            </Modal>

            <Toast ref={toast} position='top-right' /> {/*Toast tiene una prop onRemove, en el que hace algo en el momento que el toast se cierra (tanto despues de pasar un tiempo como por cerrarlo manualmente)*/}
            <WindowLoader showLoader={loading} className='whiteSpinner' />
        </div>
    );
}
